import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesRoutingModule } from './pages-routing.module';
import { PagesComponent } from './pages.component';
import { ThemeModule } from '../theme/theme.module';
import {HttpClientModule} from "@angular/common/http";
import { WelcomePageComponent } from './welcome-page/welcome-page.component';
import { SuccessComponent } from './success/success.component';
import { FailureComponent } from './failure/failure.component';
import { VerifyComponent } from './verify/verify.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ConfigurationPageComponent} from "./configuration/configuration.component";
import { SettingsHeaderComponent} from "./configuration/components/settings-header/settings-header.component";
import { OpenpayHeaderComponent } from '../shared/components/openpay-header/openpay-header.component';
import { InstallationPageComponent } from './installation/installation-component';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    PagesComponent,
    WelcomePageComponent,
    SuccessComponent,
    FailureComponent,
    VerifyComponent,
    NotFoundComponent,
    ConfigurationPageComponent,
    SettingsHeaderComponent,
    InstallationPageComponent,
    OpenpayHeaderComponent
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    ThemeModule,
    HttpClientModule,
    FormsModule
  ],
  exports: [],

})
export class PagesModule { }
